import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { ColumnMetadata } from "../metadata/ColumnMetadata";
import { EntityMetadata } from "../metadata/EntityMetadata";
import { ForeignKeyMetadata } from "../metadata/ForeignKeyMetadata";
import { IndexMetadata } from "../metadata/IndexMetadata";
import { TypeORMError } from "../error";
import { DriverUtils } from "../driver/DriverUtils";
/**
 * Creates EntityMetadata for junction tables.
 * Junction tables are tables generated by many-to-many relations.
 */
export var JunctionEntityMetadataBuilder = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function JunctionEntityMetadataBuilder(connection) {
    _classCallCheck(this, JunctionEntityMetadataBuilder);
    this.connection = connection;
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Builds EntityMetadata for the junction of the given many-to-many relation.
   */
  _createClass(JunctionEntityMetadataBuilder, [{
    key: "build",
    value: function build(relation, joinTable) {
      var _this = this;
      var _a, _b;
      var referencedColumns = this.collectReferencedColumns(relation, joinTable);
      var inverseReferencedColumns = this.collectInverseReferencedColumns(relation, joinTable);
      var joinTableName = joinTable.name || this.connection.namingStrategy.joinTableName(relation.entityMetadata.tableNameWithoutPrefix, relation.inverseEntityMetadata.tableNameWithoutPrefix, relation.propertyPath, relation.inverseRelation ? relation.inverseRelation.propertyName : "");
      var entityMetadata = new EntityMetadata({
        connection: this.connection,
        args: {
          target: "",
          name: joinTableName,
          type: "junction",
          database: joinTable.database || relation.entityMetadata.database,
          schema: joinTable.schema || relation.entityMetadata.schema,
          synchronize: joinTable.synchronize
        }
      });
      entityMetadata.build();
      // create original side junction columns
      var junctionColumns = referencedColumns.map(function (referencedColumn) {
        var joinColumn = joinTable.joinColumns ? joinTable.joinColumns.find(function (joinColumnArgs) {
          return (!joinColumnArgs.referencedColumnName || joinColumnArgs.referencedColumnName === referencedColumn.propertyName) && !!joinColumnArgs.name;
        }) : undefined;
        var columnName = joinColumn && joinColumn.name ? joinColumn.name : _this.connection.namingStrategy.joinTableColumnName(relation.entityMetadata.tableNameWithoutPrefix, referencedColumn.propertyName, referencedColumn.databaseName);
        return new ColumnMetadata({
          connection: _this.connection,
          entityMetadata: entityMetadata,
          referencedColumn: referencedColumn,
          args: {
            target: "",
            mode: "virtual",
            propertyName: columnName,
            options: {
              name: columnName,
              length: !referencedColumn.length && (DriverUtils.isMySQLFamily(_this.connection.driver) || _this.connection.driver.options.type === "aurora-mysql") && (referencedColumn.generationStrategy === "uuid" || referencedColumn.type === "uuid") ? "36" : referencedColumn.length,
              width: referencedColumn.width,
              type: referencedColumn.type,
              precision: referencedColumn.precision,
              scale: referencedColumn.scale,
              charset: referencedColumn.charset,
              collation: referencedColumn.collation,
              zerofill: referencedColumn.zerofill,
              unsigned: referencedColumn.zerofill ? true : referencedColumn.unsigned,
              enum: referencedColumn.enum,
              enumName: referencedColumn.enumName,
              foreignKeyConstraintName: joinColumn === null || joinColumn === void 0 ? void 0 : joinColumn.foreignKeyConstraintName,
              nullable: false,
              primary: true
            }
          }
        });
      });
      // create inverse side junction columns
      var inverseJunctionColumns = inverseReferencedColumns.map(function (inverseReferencedColumn) {
        var joinColumn = joinTable.inverseJoinColumns ? joinTable.inverseJoinColumns.find(function (joinColumnArgs) {
          return (!joinColumnArgs.referencedColumnName || joinColumnArgs.referencedColumnName === inverseReferencedColumn.propertyName) && !!joinColumnArgs.name;
        }) : undefined;
        var columnName = joinColumn && joinColumn.name ? joinColumn.name : _this.connection.namingStrategy.joinTableInverseColumnName(relation.inverseEntityMetadata.tableNameWithoutPrefix, inverseReferencedColumn.propertyName, inverseReferencedColumn.databaseName);
        return new ColumnMetadata({
          connection: _this.connection,
          entityMetadata: entityMetadata,
          referencedColumn: inverseReferencedColumn,
          args: {
            target: "",
            mode: "virtual",
            propertyName: columnName,
            options: {
              length: !inverseReferencedColumn.length && (DriverUtils.isMySQLFamily(_this.connection.driver) || _this.connection.driver.options.type === "aurora-mysql") && (inverseReferencedColumn.generationStrategy === "uuid" || inverseReferencedColumn.type === "uuid") ? "36" : inverseReferencedColumn.length,
              width: inverseReferencedColumn.width,
              type: inverseReferencedColumn.type,
              precision: inverseReferencedColumn.precision,
              scale: inverseReferencedColumn.scale,
              charset: inverseReferencedColumn.charset,
              collation: inverseReferencedColumn.collation,
              zerofill: inverseReferencedColumn.zerofill,
              unsigned: inverseReferencedColumn.zerofill ? true : inverseReferencedColumn.unsigned,
              enum: inverseReferencedColumn.enum,
              enumName: inverseReferencedColumn.enumName,
              foreignKeyConstraintName: joinColumn === null || joinColumn === void 0 ? void 0 : joinColumn.foreignKeyConstraintName,
              name: columnName,
              nullable: false,
              primary: true
            }
          }
        });
      });
      this.changeDuplicatedColumnNames(junctionColumns, inverseJunctionColumns);
      // set junction table columns
      entityMetadata.ownerColumns = junctionColumns;
      entityMetadata.inverseColumns = inverseJunctionColumns;
      entityMetadata.ownColumns = [].concat(_toConsumableArray(junctionColumns), _toConsumableArray(inverseJunctionColumns));
      entityMetadata.ownColumns.forEach(function (column) {
        return column.relationMetadata = relation;
      });
      // create junction table foreign keys
      // Note: UPDATE CASCADE clause is not supported in Oracle.
      // Note: UPDATE/DELETE CASCADE clauses are not supported in Spanner.
      entityMetadata.foreignKeys = relation.createForeignKeyConstraints ? [new ForeignKeyMetadata({
        entityMetadata: entityMetadata,
        referencedEntityMetadata: relation.entityMetadata,
        columns: junctionColumns,
        referencedColumns: referencedColumns,
        name: (_a = junctionColumns[0]) === null || _a === void 0 ? void 0 : _a.foreignKeyConstraintName,
        onDelete: this.connection.driver.options.type === "spanner" ? "NO ACTION" : relation.onDelete || "CASCADE",
        onUpdate: this.connection.driver.options.type === "oracle" || this.connection.driver.options.type === "spanner" ? "NO ACTION" : relation.onUpdate || "CASCADE"
      }), new ForeignKeyMetadata({
        entityMetadata: entityMetadata,
        referencedEntityMetadata: relation.inverseEntityMetadata,
        columns: inverseJunctionColumns,
        referencedColumns: inverseReferencedColumns,
        name: (_b = inverseJunctionColumns[0]) === null || _b === void 0 ? void 0 : _b.foreignKeyConstraintName,
        onDelete: this.connection.driver.options.type === "spanner" ? "NO ACTION" : relation.inverseRelation ? relation.inverseRelation.onDelete : "CASCADE",
        onUpdate: this.connection.driver.options.type === "oracle" || this.connection.driver.options.type === "spanner" ? "NO ACTION" : relation.inverseRelation ? relation.inverseRelation.onUpdate : "CASCADE"
      })] : [];
      // create junction table indices
      entityMetadata.ownIndices = [new IndexMetadata({
        entityMetadata: entityMetadata,
        columns: junctionColumns,
        args: {
          target: entityMetadata.target,
          synchronize: true
        }
      }), new IndexMetadata({
        entityMetadata: entityMetadata,
        columns: inverseJunctionColumns,
        args: {
          target: entityMetadata.target,
          synchronize: true
        }
      })];
      // finally return entity metadata
      return entityMetadata;
    }
    // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Collects referenced columns from the given join column args.
     */
  }, {
    key: "collectReferencedColumns",
    value: function collectReferencedColumns(relation, joinTable) {
      var hasAnyReferencedColumnName = joinTable.joinColumns ? joinTable.joinColumns.find(function (joinColumn) {
        return !!joinColumn.referencedColumnName;
      }) : false;
      if (!joinTable.joinColumns || joinTable.joinColumns && !hasAnyReferencedColumnName) {
        return relation.entityMetadata.columns.filter(function (column) {
          return column.isPrimary;
        });
      } else {
        return joinTable.joinColumns.map(function (joinColumn) {
          var referencedColumn = relation.entityMetadata.columns.find(function (column) {
            return column.propertyName === joinColumn.referencedColumnName;
          });
          if (!referencedColumn) throw new TypeORMError("Referenced column ".concat(joinColumn.referencedColumnName, " was not found in entity ").concat(relation.entityMetadata.name));
          return referencedColumn;
        });
      }
    }
    /**
     * Collects inverse referenced columns from the given join column args.
     */
  }, {
    key: "collectInverseReferencedColumns",
    value: function collectInverseReferencedColumns(relation, joinTable) {
      var hasInverseJoinColumns = !!joinTable.inverseJoinColumns;
      var hasAnyInverseReferencedColumnName = hasInverseJoinColumns ? joinTable.inverseJoinColumns.find(function (joinColumn) {
        return !!joinColumn.referencedColumnName;
      }) : false;
      if (!hasInverseJoinColumns || hasInverseJoinColumns && !hasAnyInverseReferencedColumnName) {
        return relation.inverseEntityMetadata.primaryColumns;
      } else {
        return joinTable.inverseJoinColumns.map(function (joinColumn) {
          var referencedColumn = relation.inverseEntityMetadata.ownColumns.find(function (column) {
            return column.propertyName === joinColumn.referencedColumnName;
          });
          if (!referencedColumn) throw new TypeORMError("Referenced column ".concat(joinColumn.referencedColumnName, " was not found in entity ").concat(relation.inverseEntityMetadata.name));
          return referencedColumn;
        });
      }
    }
  }, {
    key: "changeDuplicatedColumnNames",
    value: function changeDuplicatedColumnNames(junctionColumns, inverseJunctionColumns) {
      var _this2 = this;
      junctionColumns.forEach(function (junctionColumn) {
        inverseJunctionColumns.forEach(function (inverseJunctionColumn) {
          if (junctionColumn.givenDatabaseName === inverseJunctionColumn.givenDatabaseName) {
            var junctionColumnName = _this2.connection.namingStrategy.joinTableColumnDuplicationPrefix(junctionColumn.propertyName, 1);
            junctionColumn.propertyName = junctionColumnName;
            junctionColumn.givenDatabaseName = junctionColumnName;
            var inverseJunctionColumnName = _this2.connection.namingStrategy.joinTableColumnDuplicationPrefix(inverseJunctionColumn.propertyName, 2);
            inverseJunctionColumn.propertyName = inverseJunctionColumnName;
            inverseJunctionColumn.givenDatabaseName = inverseJunctionColumnName;
          }
        });
      });
    }
  }]);
  return JunctionEntityMetadataBuilder;
}();